import {
  SET_ACTIVE_RESOURCE
} from '../actions';

const initialState = {
};
export default function (state = initialState, action) {

  switch(action.type) {
    case SET_ACTIVE_RESOURCE:
      return action.payload;

    default:
      return state;
  }
}